
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"125","height":"156","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"stroke":"#D7D7D7","stroke-width":".635","fill":"#F6F6F6","x":".317","y":".317","width":"124.365","height":"155.365","rx":"6"}}),_c('g',{attrs:{"fill":"#BEBEBE","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M86.821 108.107H36.393c-1.214 0-2.143-.928-2.143-2.143 0-15.143 9.714-23.5 27.357-23.5s27.357 8.357 27.357 23.5c0 1.215-.928 2.143-2.143 2.143zM61.607 79.321c-7.857 0-14.214-6.928-14.214-15.428 0-8.286 6.143-14.5 14.214-14.5 8.072 0 14.214 6.214 14.214 14.5 0 8.5-6.357 15.428-14.214 15.428z"}})])])])
          )
        }
      }
    